import React from 'react';
import { ImageIcon } from '@saleshandy/design-system';

const NoProspectDetailResultScreen = ({ title, description, imageSrc }) => (
  <div className="no-result-screen">
    <ImageIcon src={imageSrc} alt="no-result-found" />
    <div className="no-result-text">
      <div className="no-result-found-title">{title}</div>
      <div className="no-result-found-description">{description}</div>
    </div>
  </div>
);

export default NoProspectDetailResultScreen;
